import { Component, OnInit, Input } from '@angular/core';
import { UsdaService } from '../../../services/usda.service';

export interface Benefit{
  description:string;
  id:string;
}
@Component({
  selector: 'benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss']
})
export class BenefitsComponent implements OnInit {


  threshold: number = 10;
  // @Input() quantity: number;
  // @Input() measureIndex: number;
  // @Input() food: Food;
  @Input() vitaminStats: Map<string, number>;
  @Input() mineralStats: Map<string, number>;
  // benefits: Array<string>;
  benefits: Array<Benefit>;
  // benefits: any;

  constructor(public api: UsdaService) { }

  ngOnChanges() {

    // this.vitaminStats.forEach((value: number, key: string) => {
    // console.log(key, value);
    // });


    // this.benefits = new Array<string>();
    this.benefits = new Array<Benefit>();

    this.api.rda.forEach((value, key: string) => {
      if (this.vitaminStats.has(value.symbol)) {
        console.log('hit with: ' + value.symbol + ' val: ' + this.vitaminStats.get(value.symbol) +
          ' for: ' + key);
        if (this.vitaminStats.get(value.symbol) >= this.threshold) {
          console.log('***hit: ' + value.symbol + ' with ' + this.vitaminStats.get(value.symbol));

          // this.benefits.push('Vit: ' + value.symbol);
          // console.log('benefits:' + JSON.stringify(value.benefits));
          console.log('benefits:' + value.benefits.length);
          // let a = value.benefits[0];
          let randomBenefit = this.randomIntFromInterval(0, value.benefits.length - 1);

          if (value.benefits && value.benefits[randomBenefit]) {
            // this.benefits.push(value.benefits[randomBenefit].desc + ' (' + value.symbol + ')');
            // this.benefits.push(description: value.benefits[randomBenefit].desc, id:key);
            this.benefits.push({description:value.benefits[randomBenefit].desc, id:key})
          }
        }
      }
      // let fdOneVitaminRDAValue = this.foodVitaminRDAStats.has(value.symbol) ? this.foodVitaminRDAStats.get(value.symbol) : 0;

      // if (fdOneVitaminRDAValue) {
      // this.vitaminGraphData.push([value.symbol, fdOneVitaminRDAValue]);
      // }

      // let fdOneMineralRDAValue = this.foodMineralRDAStats.has(value.symbol) ? this.foodMineralRDAStats.get(value.symbol) : 0;

      // if (fdOneMineralRDAValue) {
      // this.mineralGraphData.push([value.symbol, fdOneMineralRDAValue]);
      // }
    });




    // });
    // if (this.quantity >= 0 && this.measureIndex >= 0) {
    // console.log('quantity: ' + this.quantity + ' measure index: ' + this.measureIndex);
    // } else {
    // console.log('no changes');
    // }

  }

  /**
   * Get a random number between 2 endpoints, min and max included
   * @param min minimum
   * @param max maximum
   */
  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  ngOnInit() {
  }

}
